import { defineRouting } from "next-intl/routing";

// =============================================================================

export const routing = defineRouting({
  locales: ["en", "fr"],
  // French at the root (/projects), English under /en (/en/projects)
  defaultLocale: "fr",
  localePrefix: "as-needed",
  // The language of a first visit is picked by the proxy (proxy.ts)
  localeDetection: false,
  // hreflang links come from the page metadata (createPageMetadata): no
  // second, diverging set in a Link header
  alternateLinks: false,
});

export type AppLocale = (typeof routing.locales)[number];

/** Version shown to the visitors whose browser is not in French */
export const FALLBACK_LOCALE: AppLocale = "en";

// =============================================================================
